import apiClient from './apiClient';

export async function fetchEndpoints() {
  const { data } = await apiClient.get('/endpoints');
  const rows = Array.isArray(data) ? data : [];
  return rows.map((d) => ({
    ...d, riskScore: d.risk_score, lastSeen: d.last_seen_at,
    isolated: d.status === 'ISOLATED', user: '—', avStatus: 'protected', encrypted: true
  }));
}

export async function fetchEndpointAlerts() {
  const { data } = await apiClient.get('/endpoints/findings');
  const rows = Array.isArray(data) ? data : [];
  return rows.map((f) => ({
    ...f, type: f.title, timestamp: f.created_at,
    severity: String(f.severity).toLowerCase(), hostname: f.endpoint_id
  }));
}

export async function isolateEndpoint(id) {
  const { data } = await apiClient.post(`/endpoints/${id}/isolate`);
  return { id, commandId: data.id, isolationPending: data.status === 'PENDING_APPROVAL', isolated: false };
}

export async function updateEndpointFindingStatus(id, status) {
  const { data } = await apiClient.patch(`/endpoints/findings/${id}/status`, { status });
  return data;
}

export async function fetchCommands(status) {
  const { data } = await apiClient.get('/endpoints/commands', { params: status ? { status } : {} });
  return data;
}

export async function approveCommand(id) {
  const { data } = await apiClient.post(`/endpoints/commands/${id}/approve`);
  return data;
}

export async function rejectCommand(id, reason) {
  const { data } = await apiClient.post(`/endpoints/commands/${id}/reject`, { reason });
  return data;
}

export async function recomputeEndpointRisk(id) {
  const { data } = await apiClient.post(`/endpoints/risk/${id}/recompute`);
  return data;
}

export async function registerEndpoint(payload) {
  const { data } = await apiClient.post('/endpoints/check-in', payload);
  return data;
}

export async function submitRansomwareTelemetry(payload) {
  const { data } = await apiClient.post('/endpoints/ransomware/telemetry', payload);
  return data;
}
